import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'clsx';
import { GalleryIndicatorElement } from './styles/gallery-indicator.styled';
export const GalleryIndicator = ({ reference, active, index }) => {
    const indicatorClassnames = classNames('PONCHO-gallery__indicator', {
        'PONCHO-gallery__indicator--active': active,
    });
    return (_jsx(GalleryIndicatorElement, { htmlFor: `gallery-${reference}-slide-${index}`, className: indicatorClassnames, "$isActive": active, children: _jsx("span", { children: "\u00B7" }) }));
};
